"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTokenAdminStorageV1Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "currentFallbackAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lastPulledReserve",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pullReservesPublicAccess",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "reserveRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "reserveRatioBase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "reserveRecipient",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardRatioBase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610190806100206000396000f3fe608060405234801561001057600080fd5b50600436106100785760003560e01c80630c7d5cd81461007d5780632fb7868d146100995780636429ce31146100b6578063646033bc146100c5578063a64c7c4b146100b6578063ad31ec02146100ce578063b3e921c8146100f9578063fb8d265b1461010c575b600080fd5b61008660065481565b6040519081526020015b60405180910390f35b6005546100a69060ff1681565b6040519015158152602001610090565b610086670de0b6b3a764000081565b61008660075481565b6001546100e1906001600160a01b031681565b6040516001600160a01b039091168152602001610090565b6000546100e1906001600160a01b031681565b61008661011a36600461012c565b60026020526000908152604090205481565b60006020828403121561013d578081fd5b81356001600160a01b0381168114610153578182fd5b939250505056fea2646970667358221220dff4f309e9b1ba3a240dbd9dd4b399939984df6fee0576c32abc89f2cc1bc84e64736f6c63430008030033";
class TTokenAdminStorageV1Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TTokenAdminStorageV1Factory = TTokenAdminStorageV1Factory;
TTokenAdminStorageV1Factory.bytecode = _bytecode;
TTokenAdminStorageV1Factory.abi = _abi;
//# sourceMappingURL=TTokenAdminStorageV1Factory.js.map